module.exports = __webpack_public_path__ + "static/hit-makers-ad5a815a7925e0246c3d1cfb40b37925.jpg";